import React from "react";
import Image from "next/legacy/image";
import {
  StyledVideoPlaceholder,
  PlaceholderLine,
  PlaceholderBottom,
  PlaceholderLogo,
  PlaceholderText,
  PlaceholderPlayIcon
} from "./video-player-placeholder.styles";
import colearnLogo from "public/assets/colearn_logo.svg";
import { Play } from "components/icons/play";

const VIDEO_PLAYER_PLACEHOLDER_LINE_COUNT = 14;
const VideoPlayerPlaceholder: React.FC = () => {
  return (
    <StyledVideoPlaceholder>
      {Array.from(Array(VIDEO_PLAYER_PLACEHOLDER_LINE_COUNT).keys()).map(
        (index) => (
          <PlaceholderLine key={`placeholder-line-${index}`}></PlaceholderLine>
        )
      )}
      <PlaceholderPlayIcon data-testid="video-placeholder-play-icon">
        <Play />
      </PlaceholderPlayIcon>

      <PlaceholderBottom>
        <PlaceholderText>www.colearn.id</PlaceholderText>
        <PlaceholderLogo>
          <Image
            src={colearnLogo}
            alt="Colearn Logo"
            layout="fill"
            objectFit="fill"
          />
        </PlaceholderLogo>
      </PlaceholderBottom>
    </StyledVideoPlaceholder>
  );
};

export { VideoPlayerPlaceholder };
